import React from 'react';

import styles from './MetricBox.module.scss';

interface IMetricBoxProps {
  icon?: React.ReactNode;
  title: string;
  value: string | number;
  className?: string;
  subtitle?: string;
}

const MetricBox = ({ icon, title, value, className, subtitle }: IMetricBoxProps) => (
  <div className={`${styles.wrapper}${className ? ` ${className}` : ''}`}>
    {icon && <div className={styles.icon}>{icon}</div>}
    <div className={styles.title}>{title}</div>
    {!subtitle && <div className={styles.value}>{value}</div>}
    {subtitle && <div className={styles.value}>{subtitle}</div>}
  </div>
);

MetricBox.defaultProps = {
  icon: null,
  className: '',
  subtitle: undefined,
};

export default MetricBox;
